module.exports = __webpack_public_path__ + "img/pic-01.d63a4881.png";